export default __webpack_public_path__ + "static/media/east.a9cf98d8.svg";